import { Link } from 'react-router-dom';
import { ShieldX, ArrowLeft } from 'lucide-react';

export function UnauthorizedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="text-center">
        <ShieldX className="w-16 h-16 mx-auto text-red-400 mb-6" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Accesso non autorizzato
        </h1>
        <p className="text-gray-600 mb-8">
          Non hai i permessi necessari per accedere a questa pagina.
        </p>
        <Link to="/" className="btn-primary inline-flex">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Torna alla dashboard
        </Link>
      </div>
    </div>
  );
}
